// ─── CoGrad impact figures — one source for the whole site ───────────────────
// Before this file the same claim appeared with different values on different
// pages: 50K+ teachers on the home page against 10,000+ on the training page,
// 3,00,000+ students in most places against 1L+ beside Medha AI. A visitor who
// read two pages saw two companies.
//
// So every page-level figure that describes CoGrad as a whole is now read from
// here. Do not re-type one of these numbers into a component: import it. If a
// figure changes, change it here, move `AS_OF` to the month it was counted,
// and the whole site moves with it.
//
// Programme-level figures (how many teachers one KVS programme trained, how
// many schools one scheme covers) are NOT company-wide and stay with their
// programme — but they must never exceed the totals below.

/** The month these figures were last counted. Shown beneath every stat group. */
export const AS_OF = "October 2026";

/** The line printed under a group of figures. */
export const AS_OF_NOTE = `Figures as of ${AS_OF}`;

/**
 * Each entry pairs a raw number with the two ways it is written.
 *
 * `display` is the canonical form and is what almost every page shows.
 * `short` exists only for the few places too narrow for the long form — a
 * product window footer, a popup. Both must state the same number as `n`;
 * that is the whole point of keeping them on one line together.
 */
export const impact = {
  students:  { n: 200000, display: "2,00,000+", short: "2L+",    label: "Students Impacted"   },
  schools:   { n: 1700,   display: "1,700+",    short: "1,700+", label: "Schools Partnered"   },
  teachers:  { n: 10000,  display: "10,000+",   short: "10K+",   label: "Teachers Trained"    },
  incubated: { n: 26,     display: "26+",       short: "26+",    label: "Schools Incubated"   },
  workshops: { n: 5000,   display: "5,000+",    short: "5K+",    label: "Workshops Conducted" },
  states:    { n: 12,     display: "12+",       short: "12+",    label: "States Covered"      },
  stories:   { n: 2000,   display: "2,000+",    short: "2K+",    label: "Success Stories"     },
  years:     { n: 6,      display: "6+",        short: "6+",     label: "Years of Impact"     },
};

/**
 * Figures quoted from NITI Aayog's Frontier Tech feature.
 *
 * These are the article's own numbers, not ours, and the article's school
 * count is far larger than the 1,700 partner schools we report. Both can
 * stand — they count different things — but only if the page says where the
 * number came from, which is what `source` is for. Never quietly reconcile
 * these with `impact` above: that would misquote a third party.
 */
export const nitiFigures = {
  source: "As reported by NITI Aayog, August 2026",
  updated: "August 2026",
};
